import { useQuery } from "@tanstack/react-query";

import { contentGet, type SiteContent } from "@/api_client";

import { contentQueryKey } from "@/hooks/api/content/contentQueryKey";

export const useContentValue = <K extends keyof SiteContent>(key: K) => {
  return useQuery({
    queryKey: contentQueryKey,
    queryFn: () =>
      contentGet({ path: { language: null } }).then((res) => res.data),
    staleTime: Infinity,
    placeholderData: (prev) => prev,
    select: (data) => data[key],
  });
};
